import { useEffect } from "react";
import { Trans } from "react-i18next";

import type { ErrorDetailResponse } from "@/api/bale.zod";

export function ErrorDetail({ error }: { error?: ErrorDetailResponse | null }) {
  useEffect(() => console.error(error), [error]);
  if (!error) return null;
  // NOTE: ValidationError is meant to be handled by `<Form>`, and not shown directly
  if (error.code === "ValidationError") return null;
  return (
    // oxlint-disable-next-line i18n/missing-translation
    <Trans ns="errors" i18nKey={error.code} values={error.detail}>
      {/* oxlint-disable-next-line jsx-no-literals */}
      {error.code}: {error.message}
    </Trans>
  );
}
